import { fetchEmailTypes } from 'admin/admin.saga';
import * as AdminSelectors from 'admin/admin.selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as dto from 'client/dto';

import { SimpleCrudTable } from '../_common/SimpleCrudTable';

const UserEmailTypes: React.FC = () => {
  const dispatch = useDispatch();

  const dataList = useSelector(AdminSelectors.emailTypesSelector);
  const isLoading = useSelector(AdminSelectors.isAdminLoadingSelector);

  useEffect(() => {
    dispatch(fetchEmailTypes());
  }, []);

  return (
    <div>
      <h1>User Email Types</h1>

      <SimpleCrudTable<dto.EmailTypeModel, any>
        loading={isLoading}
        list={dataList}
        entityType="Email Type"
        columns={[
          { name: 'Id', getter: x => x.id },
          { name: 'Name', getter: x => x.name },
        ]}
        keyGetter={x => `${x.id}`}
      />
    </div>
  );
};

export default UserEmailTypes;
